import React, { useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import MessageComposer from '../MessageComposer';
import '../ThreadQuill.css';
import MessageBubble from '../MessageBubble';
import {
  fetchAdminThread,
  fetchAdminMoreMessages,
  sendAdminReply,
  markAdminThreadRead,
  clearThread,
  fetchAdminUnreadCount,
} from '../store/adminConversationsSlice';


const CoachAdminThreadPage = ({ match }) => {
  const { id: conversationId } = match.params;
  const dispatch = useDispatch();
  const history = useHistory();
  const { activeThread, messages, nextCursor, loading } = useSelector(
    ({ adminConversations }) => adminConversations
  );
  const bottomRef = useRef(null);
  const initialScrollDone = useRef(false);

  useEffect(() => {
    dispatch(fetchAdminThread(conversationId));
    dispatch(markAdminThreadRead(conversationId)).then(() => dispatch(fetchAdminUnreadCount()));
    return () => dispatch(clearThread());
  }, [dispatch, conversationId]);

  const scrollToBottom = useCallback((behavior) => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: behavior || 'auto', block: 'end' });
    }
  }, []);

  useEffect(() => {
    if (!initialScrollDone.current && messages.length > 0) {
      scrollToBottom('auto');
      initialScrollDone.current = true;
    }
  }, [messages, scrollToBottom]);

  const handleLoadMore = () => {
    if (nextCursor) dispatch(fetchAdminMoreMessages(conversationId, nextCursor));
  };

  const admin = activeThread?.adminUserId;
  const adminName = admin ? `${admin.firstName} ${admin.lastName}` : 'Kajetan Borecki';

  if (loading && !activeThread) {
    return (
      <div style={{ textAlign: 'center', padding: '60px', color: '#64748b' }}>
        Loading conversation...
      </div>
    );
  }

  return (
    <div style={{ padding: '32px 0' }}>
      <div style={{ marginBottom: '16px' }}>
        <button
          type="button"
          onClick={() => history.push('/messages')}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#2e496b',
            fontSize: '14px',
            padding: 0,
          }}
        >
          &#8592; Back to Messages
        </button>
        <h2 style={{ margin: '8px 0 0', fontSize: '18px', color: '#1e293b' }}>
          Kajetan Borecki
        </h2>
      </div>

      <div
        style={{
          background: '#ffffff',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        {/* Message list */}
        <div style={{ padding: '0' }}>
          {nextCursor && (
            <div style={{ textAlign: 'center', padding: '12px' }}>
              <button
                type="button"
                onClick={handleLoadMore}
                style={{
                  background: 'none',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  padding: '4px 12px',
                  fontSize: '12px',
                  color: '#64748b',
                  cursor: 'pointer',
                }}
              >
                Load earlier messages
              </button>
            </div>
          )}
          {messages.map(msg => (
            <MessageBubble
              key={msg._id}
              message={msg}
              isSentByMe={msg.senderType === 'coach'}
              senderLabel={msg.senderType === 'coach' ? 'You' : adminName}
              senderType={msg.senderType}
            />
          ))}
          <div ref={bottomRef} />
        </div>

        {/* Reply input */}
        <MessageComposer
          threadType="admin-conversations"
          conversationId={conversationId}
          placeholder="Type a message..."
          onSend={({ text, file, draftRevision }) => dispatch(sendAdminReply({ conversationId, text, file, draftRevision }))}
          onSent={() => { setTimeout(() => scrollToBottom('smooth'), 50); }}
        />
      </div>
    </div>
  );
};

export default CoachAdminThreadPage;
